import { useTranslation } from 'react-i18next';

/** P-60 (D-236): "הודעה חדשה ↓" — shown instead of yanking the scroll when a message arrives while reading above. */
export default function NewMessagePill({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="sticky bottom-2 z-10 flex justify-center pointer-events-none" role="status" aria-live="polite">
      <button
        type="button"
        onClick={onClick}
        className="pointer-events-auto rounded-full bg-accent px-3 py-1 text-xs font-medium text-white shadow-md hover:opacity-90"
      >
        {t('chat.newMessageBelow')}
      </button>
    </div>
  );
}
